import React from 'react';

import {AdaptiveSkillPathsCard} from '../cards/AdaptiveSkillPathsCard';
import {BrowseSubjectsTile, CreateAssignmentTile} from '../cards/homeTiles';

/** Has-classes classwork actions: personalized adaptive skill paths + assignment + browse. */
export const ClassworkActions = () => (
  <section aria-label='Classwork' className='gap-x2 flex flex-col'>
    <AdaptiveSkillPathsCard />
    <div className='gap-x2 s:grid-cols-[2fr_1fr] grid grid-cols-1'>
      <CreateAssignmentTile description='Hand-pick questions from any question bank subjects and assign them to your classes.' />
      <BrowseSubjectsTile description="Explore Albert's subject library." />
    </div>
  </section>
);
